// Predykat wpięcia bramki CompanyKeyBootstrapGate.
//
// Wydzielony z tego samego powodu co bliźniaczy predykat NoCompanyGate: decyzja
// o ZABLOKOWANIU całej aplikacji ma być jawna, krótka i testowalna bez renderu.
//
// Ta bramka łapie stan, którego NoCompanyGate z definicji nie widzi: firma ISTNIEJE, więc
// `hasCompany === true`, ale nie ma ani jednej generacji klucza (`ActiveKeyId === null`).
// Dotyczy firm założonych przed wejściem modelu kluczy firmowych.

import { EXEMPT_PATH_PREFIXES } from "components/NoCompanyGate/shouldShow";

export interface ICompanyKeyBootstrapGateInput {
  /** Czy zalogowany należy do firmy (CompanyContext.hasCompany). */
  hasCompany: boolean;
  /** Czy trwa pobieranie firmy albo jej kluczy — w trakcie ładowania NIE blokujemy. */
  isLoading: boolean;
  /**
   * Czy pobranie kluczy firmy się NIE UDAŁO. Awaria wygląda identycznie jak „brak
   * generacji", a to dwa różne stany: przy błędzie namawialibyśmy na utworzenie DRUGIEGO
   * klucza firmie, która swój ma — i której danych ten nowy klucz już by nie odszyfrował.
   */
  isError?: boolean;
  /**
   * Identyfikator aktywnej generacji (`ICompanyKeysView.ActiveKeyId`). `null` = firma nie ma
   * klucza; `undefined` = odpowiedź jeszcze nie dotarła i NIE wolno na tej podstawie blokować.
   */
  activeKeyId?: string | null;
  /** Bieżąca ścieżka — te same wyjątki co dla NoCompanyGate. */
  pathname?: string;
}

export const shouldShowCompanyKeyBootstrapGate = ({
  hasCompany,
  isLoading,
  isError,
  activeKeyId,
  pathname,
}: ICompanyKeyBootstrapGateInput): boolean => {
  // Bez firmy pierwszeństwo ma NoCompanyGate — dwie bramki naraz nie mają sensu.
  if (!hasCompany) return false;

  // Fail-open, dokładnie jak w NoCompanyGate: brak odpowiedzi nie jest dowodem braku klucza.
  if (isLoading || isError) return false;
  if (activeKeyId === undefined) return false;

  if (activeKeyId !== null) return false;

  if (
    pathname &&
    EXEMPT_PATH_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    )
  )
    return false;

  return true;
};
